import React from 'react';
import PageHero from '../components/ui/PageHero';
import { groupeCompanies } from '../data/mock';
import { ExternalLink } from 'lucide-react';
import SEO from '../components/SEO';

const GroupePage = () => {
  return (
    <div>
      <SEO
        title="Groupe QVT — partenaires & synergies"
        description="Découvrez le groupe Mon Evénemenciel et ses entreprises partenaires : Ma Conciergerie, Presta+, Kowork. Ensemble pour améliorer la qualité de vie au travail."
        keywords="groupe Mon Evénemenciel, Ma Conciergerie, Presta+, Kowork, QVT, qualité vie travail, services entreprise"
        url="/groupe"
        image="/img/photo-groupe.webp"
      />
      <PageHero
        title="Le Groupe"
        subtitle="Seul on va plus vite, ensemble on va plus loin !"
        backgroundImage="/img/photo-groupe.webp"
      />

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Introduction */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <p className="text-brand-petrol/70 text-lg leading-relaxed">
              Un groupe unit par la même motivation : Développer des outils performants, adaptés, à la portée de tous pour améliorer la qualité de vie au travail pour les collaborateurs et les entreprises en apportant services, bien-être et animations.
            </p>
            <p className="text-[#96452f] font-medium text-xl mt-4 font-display italic">
              L'environnement de travail deviendra alors plus attractif pour tous !
            </p>
          </div>

          {/* Companies */}
          <div className="space-y-16">
            {groupeCompanies.map((company, index) => (
              <div
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center bg-brand-ivory rounded-3xl p-8 lg:p-12`}
              >
                {/* Logo */}
                <div className="lg:w-1/3 flex justify-center">
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="h-24 w-auto"
                   loading="lazy" decoding="async" />
                </div>

                {/* Content */}
                <div className="lg:w-2/3">
                  <h2 className="text-2xl font-display text-brand-petrol mb-2">
                    {company.name}
                  </h2>
                  <h3 className="text-xl text-[#96452f] font-display italic mb-4">
                    {company.subtitle}
                  </h3>
                  <p className="text-brand-petrol/70 leading-relaxed mb-4">
                    {company.description}
                  </p>
                  {company.features && (
                    <ul className="space-y-2 mb-6">
                      {company.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <span className="text-[#D08154] mr-2">•</span>
                          <span className="text-brand-petrol/70">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <a
                    href={company.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#96452f] text-white px-6 py-3 rounded-md font-medium hover:bg-[#7a3826] transition-all duration-300 hover:scale-105"
                  >
                    En savoir plus
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GroupePage;
